import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { useMetaArticleSchema } from './hooks/useMetaArticleSchema';

export const MetaArticleSchema: React.FC = () => {
	const {
		data: { schemaJson },
	} = useMetaArticleSchema();

	return (
		<Helmet>
			<script type="application/ld+json">{schemaJson}</script>
		</Helmet>
	);
};
